import script from "./TableLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./TableLoading.vue?vue&type=script&setup=true&lang=js"

import "./TableLoading.vue?vue&type=style&index=0&id=0eda1882&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eda1882"]])

export default __exports__